// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Workspaces / Team members pages
   Two standalone account-level pages (/workspaces, /team-members), each a
   sidebar entry next to Agents. Left-aligned, glassmorphism cards matching
   userSettings.css. */

.team-page {
  margin: 0;
  padding: 22px 24px 48px;
  color: #1f2937;
  max-width: 1000px;
}

.team-card {
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding: 20px;
  border: 1px solid #e5e7eb;
  border-radius: 10px;
  background: rgba(255, 255, 255, 0.75);
  backdrop-filter: blur(10px);
  margin-bottom: 20px;
}

.team-card-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
}

.team-card-title {
  margin: 0;
  font-size: 18px;
  font-weight: 600;
  color: #111827;
}

.team-card-subtitle {
  margin: 0;
  color: #6b7280;
  font-size: 13px;
}

.team-inline-form {
  display: flex;
  gap: 12px;
  flex-wrap: wrap;
  align-items: center;
}

.team-inline-form > .MuiTextField-root,
.team-inline-form > .MuiFormControl-root {
  flex: 1 1 220px;
  max-width: 360px;
}

.team-empty {
  padding: 8px 0;
  color: #6b7280;
  font-size: 13px;
}

.team-loading {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px 0;
  color: #5616ea;
  font-size: 22px;
}

.team-error,
.team-success {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 10px 14px;
  border-radius: 8px;
  margin-bottom: 14px;
  font-size: 14px;
}

.team-banner-close {
  margin-left: auto;
  background: transparent;
  border: none;
  color: inherit;
  cursor: pointer;
  padding: 4px 6px;
  border-radius: 4px;
  font-size: 14px;
  opacity: 0.7;
  transition: opacity 0.15s ease, background-color 0.15s ease;
}

.team-banner-close:hover {
  opacity: 1;
  background-color: rgba(0, 0, 0, 0.06);
}

.team-error {
  background: #fef2f2;
  border-left: 4px solid #ef4444;
  color: #991b1b;
}

.team-success {
  background: #f0fdf4;
  border-left: 4px solid #22c55e;
  color: #166534;
}

/* --- Workspace list (inside the Workspaces tab) ------------------- */
.team-ws-list {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.team-ws-row {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 10px 12px;
  border-radius: 8px;
  border: 1px solid #e5e7eb;
  background: #ffffff;
  transition: border-color 0.12s ease, background 0.12s ease;
}

.team-ws-row.current {
  border-color: #5616ea;
  background: #f7f4ff;
}

.team-ws-row.clickable {
  cursor: pointer;
}

.team-ws-row.clickable:hover {
  border-color: #5616ea;
  background: #faf8ff;
}

.team-ws-row.clickable:focus-visible {
  outline: 2px solid #5616ea;
  outline-offset: 2px;
}

.team-ws-row .team-ws-main {
  flex: 1 1 auto;
  display: flex;
  flex-direction: column;
  min-width: 0;
}

.team-ws-name {
  font-size: 14px;
  font-weight: 600;
  color: #111827;
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
}

.team-ws-meta {
  font-size: 12px;
  color: #6b7280;
  margin-top: 2px;
}

.team-ws-actions {
  display: flex;
  align-items: center;
  gap: 4px;
  flex-shrink: 0;
}

.team-ws-active {
  font-size: 11px;
  font-weight: 600;
  color: #5616ea;
  text-transform: uppercase;
  letter-spacing: 0.4px;
  padding: 4px 8px;
  border-radius: 999px;
  background: rgba(86, 22, 234, 0.08);
}

.team-role-badge {
  display: inline-flex;
  align-items: center;
  font-size: 10px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.4px;
  padding: 3px 7px;
  border-radius: 999px;
  background: #e5e7eb;
  color: #374151;
}

.team-role-badge.owner { background: #ede9fe; color: #5b21b6; }
.team-role-badge.admin { background: #dbeafe; color: #1d4ed8; }
.team-role-badge.write { background: #d1fae5; color: #065f46; }
.team-role-badge.read  { background: #f3f4f6; color: #4b5563; }

/* "+ Create workspace" row inside the same list */
.team-ws-row.add {
  border-style: dashed;
  background: transparent;
  color: #5616ea;
  cursor: pointer;
  justify-content: flex-start;
  gap: 10px;
}

.team-ws-row.add:hover {
  background: #f7f4ff;
}

.team-ws-add-text {
  font-size: 14px;
  font-weight: 600;
  color: #5616ea;
}

/* Inline create / rename form rendered in place of a row */
.team-ws-row.editing {
  background: #ffffff;
  border-color: #5616ea;
}

.team-ws-row .team-ws-edit-form {
  display: flex;
  align-items: center;
  gap: 8px;
  width: 100%;
}

/* --- Members table ----------------------------------------------- */
.team-table-wrap {
  /* Horizontally scrollable so wide tables (the 6-column Workspaces table, or
     the Actions column on narrow screens) can be reached instead of spilling
     off-screen. overflow-y is pinned to \`hidden\` rather than the default
     \`visible\` — CSS would coerce \`visible\` to \`auto\` next to \`overflow-x: auto\`
     and pop a vertical scrollbar on the icon hover-scale. The hover-scale stays
     well within the 14px cell padding, so \`hidden\` never clips it. */
  overflow-x: auto;
  overflow-y: hidden;
}

/* Right-aligned cluster for action buttons (rename/leave/delete, save/cancel,
   remove member, revoke invite, etc.) so they share consistent spacing. */
.team-actions-row {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  justify-content: flex-end;
}

.team-table {
  width: 100%;
  /* Keep the columns readable; below this the wrapper scrolls horizontally
     instead of squashing names/emails and clipping the Actions column. */
  min-width: 520px;
  border-collapse: collapse;
  font-size: 14px;
}

.team-table th,
.team-table td {
  text-align: left;
  padding: 14px 12px;
  border-bottom: 1px solid #e5e7eb;
  vertical-align: middle;
  color: #1f2937;
}

/* Align the first column flush with the card title (no extra left inset). */
.team-table th:first-child,
.team-table td:first-child {
  padding-left: 0;
}

.team-table th:last-child,
.team-table td:last-child {
  padding-right: 0;
}

.team-table thead th {
  font-size: 12px;
  text-transform: uppercase;
  letter-spacing: 0.4px;
  color: #5616ea;
  font-weight: 600;
  background: transparent;
  border-bottom: 1px solid #cbd5e1;
}

.team-table tbody tr {
  transition: background-color 0.12s ease;
}

.team-table tbody tr:last-child td {
  border-bottom: none;
}

/* Workspaces table: clickable rows trigger the switch-confirm modal. */
.team-table tbody tr.team-ws-tr.clickable {
  cursor: pointer;
}

.team-table tbody tr.team-ws-tr.clickable:hover td {
  background: #faf8ff;
}

.team-table tbody tr.team-ws-tr.clickable:focus-visible {
  outline: 2px solid #5616ea;
  outline-offset: -2px;
}

.team-table tbody tr.team-ws-tr.editing td {
  background: #faf8ff;
}

/* Right-align the actions header to match the actions cell. */
.team-table th:last-child {
  text-align: right;
}

/* Small leading marker so each member row reads as a discrete entry
   without using a clickable-feeling hover background. */
.team-member-name {
  display: inline-flex;
  align-items: center;
  gap: 6px;
}

.team-member-dot {
  display: inline-block;
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: #5616ea;
  flex: 0 0 auto;
}

.team-actions-cell {
  text-align: right !important;
  white-space: nowrap;
  width: 1%;
}

/* Tabs container — left aligned, single bottom margin */
.team-tabs-wrap {
  margin-bottom: 16px;
}
`, "",{"version":3,"sources":["webpack://./src/pages/Team.css"],"names":[],"mappings":"AAAA;;;sBAGsB;;AAEtB;EACE,SAAS;EACT,uBAAuB;EACvB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,aAAa;EACb,yBAAyB;EACzB,mBAAmB;EACnB,qCAAqC;EACrC,2BAA2B;EAC3B,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,eAAe;EACf,mBAAmB;AACrB;;AAEA;;EAEE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA;;EAEE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,uBAAuB;EACvB,YAAY;EACZ,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,YAAY;EACZ,2DAA2D;AAC7D;;AAEA;EACE,UAAU;EACV,qCAAqC;AACvC;;AAEA;EACE,mBAAmB;EACnB,8BAA8B;EAC9B,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,8BAA8B;EAC9B,cAAc;AAChB;;AAEA,uEAAuE;AACvE;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,0DAA0D;AAC5D;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,qBAAqB;EACrB,gBAAgB;EAChB,oBAAoB;EACpB,mCAAmC;AACrC;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;EACrB,gBAAgB;EAChB,oBAAoB;EACpB,mBAAmB;EACnB,cAAc;AAChB;;AAEA,yBAAyB,mBAAmB,EAAE,cAAc,EAAE;AAC9D,yBAAyB,mBAAmB,EAAE,cAAc,EAAE;AAC9D,yBAAyB,mBAAmB,EAAE,cAAc,EAAE;AAC9D,yBAAyB,mBAAmB,EAAE,cAAc,EAAE;;AAE9D,kDAAkD;AAClD;EACE,oBAAoB;EACpB,uBAAuB;EACvB,cAAc;EACd,eAAe;EACf,2BAA2B;EAC3B,SAAS;AACX;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA,2DAA2D;AAC3D;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,WAAW;AACb;;AAEA,sEAAsE;AACtE;EACE;;;;;qEAKmE;EACnE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;0EAC0E;AAC1E;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX;yEACuE;EACvE,gBAAgB;EAChB,yBAAyB;EACzB,eAAe;AACjB;;AAEA;;EAEE,gBAAgB;EAChB,kBAAkB;EAClB,gCAAgC;EAChC,sBAAsB;EACtB,cAAc;AAChB;;AAEA,4EAA4E;AAC5E;;EAEE,eAAe;AACjB;;AAEA;;EAEE,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,yBAAyB;EACzB,qBAAqB;EACrB,cAAc;EACd,gBAAgB;EAChB,uBAAuB;EACvB,gCAAgC;AAClC;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,mBAAmB;AACrB;;AAEA,uEAAuE;AACvE;EACE,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,0BAA0B;EAC1B,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,8DAA8D;AAC9D;EACE,iBAAiB;AACnB;;AAEA;wDACwD;AACxD;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,qBAAqB;EACrB,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,4BAA4B;EAC5B,mBAAmB;EACnB,SAAS;AACX;;AAEA,wDAAwD;AACxD;EACE,mBAAmB;AACrB","sourcesContent":["/* Workspaces / Team members pages\r\n   Two standalone account-level pages (/workspaces, /team-members), each a\r\n   sidebar entry next to Agents. Left-aligned, glassmorphism cards matching\r\n   userSettings.css. */\r\n\r\n.team-page {\r\n  margin: 0;\r\n  padding: 22px 24px 48px;\r\n  color: #1f2937;\r\n  max-width: 1000px;\r\n}\r\n\r\n.team-card {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 12px;\r\n  padding: 20px;\r\n  border: 1px solid #e5e7eb;\r\n  border-radius: 10px;\r\n  background: rgba(255, 255, 255, 0.75);\r\n  backdrop-filter: blur(10px);\r\n  margin-bottom: 20px;\r\n}\r\n\r\n.team-card-header {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n  gap: 12px;\r\n}\r\n\r\n.team-card-title {\r\n  margin: 0;\r\n  font-size: 18px;\r\n  font-weight: 600;\r\n  color: #111827;\r\n}\r\n\r\n.team-card-subtitle {\r\n  margin: 0;\r\n  color: #6b7280;\r\n  font-size: 13px;\r\n}\r\n\r\n.team-inline-form {\r\n  display: flex;\r\n  gap: 12px;\r\n  flex-wrap: wrap;\r\n  align-items: center;\r\n}\r\n\r\n.team-inline-form > .MuiTextField-root,\r\n.team-inline-form > .MuiFormControl-root {\r\n  flex: 1 1 220px;\r\n  max-width: 360px;\r\n}\r\n\r\n.team-empty {\r\n  padding: 8px 0;\r\n  color: #6b7280;\r\n  font-size: 13px;\r\n}\r\n\r\n.team-loading {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  padding: 24px 0;\r\n  color: #5616ea;\r\n  font-size: 22px;\r\n}\r\n\r\n.team-error,\r\n.team-success {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 10px;\r\n  padding: 10px 14px;\r\n  border-radius: 8px;\r\n  margin-bottom: 14px;\r\n  font-size: 14px;\r\n}\r\n\r\n.team-banner-close {\r\n  margin-left: auto;\r\n  background: transparent;\r\n  border: none;\r\n  color: inherit;\r\n  cursor: pointer;\r\n  padding: 4px 6px;\r\n  border-radius: 4px;\r\n  font-size: 14px;\r\n  opacity: 0.7;\r\n  transition: opacity 0.15s ease, background-color 0.15s ease;\r\n}\r\n\r\n.team-banner-close:hover {\r\n  opacity: 1;\r\n  background-color: rgba(0, 0, 0, 0.06);\r\n}\r\n\r\n.team-error {\r\n  background: #fef2f2;\r\n  border-left: 4px solid #ef4444;\r\n  color: #991b1b;\r\n}\r\n\r\n.team-success {\r\n  background: #f0fdf4;\r\n  border-left: 4px solid #22c55e;\r\n  color: #166534;\r\n}\r\n\r\n/* --- Workspace list (inside the Workspaces tab) ------------------- */\r\n.team-ws-list {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 8px;\r\n}\r\n\r\n.team-ws-row {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 12px;\r\n  padding: 10px 12px;\r\n  border-radius: 8px;\r\n  border: 1px solid #e5e7eb;\r\n  background: #ffffff;\r\n  transition: border-color 0.12s ease, background 0.12s ease;\r\n}\r\n\r\n.team-ws-row.current {\r\n  border-color: #5616ea;\r\n  background: #f7f4ff;\r\n}\r\n\r\n.team-ws-row.clickable {\r\n  cursor: pointer;\r\n}\r\n\r\n.team-ws-row.clickable:hover {\r\n  border-color: #5616ea;\r\n  background: #faf8ff;\r\n}\r\n\r\n.team-ws-row.clickable:focus-visible {\r\n  outline: 2px solid #5616ea;\r\n  outline-offset: 2px;\r\n}\r\n\r\n.team-ws-row .team-ws-main {\r\n  flex: 1 1 auto;\r\n  display: flex;\r\n  flex-direction: column;\r\n  min-width: 0;\r\n}\r\n\r\n.team-ws-name {\r\n  font-size: 14px;\r\n  font-weight: 600;\r\n  color: #111827;\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 8px;\r\n  flex-wrap: wrap;\r\n}\r\n\r\n.team-ws-meta {\r\n  font-size: 12px;\r\n  color: #6b7280;\r\n  margin-top: 2px;\r\n}\r\n\r\n.team-ws-actions {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 4px;\r\n  flex-shrink: 0;\r\n}\r\n\r\n.team-ws-active {\r\n  font-size: 11px;\r\n  font-weight: 600;\r\n  color: #5616ea;\r\n  text-transform: uppercase;\r\n  letter-spacing: 0.4px;\r\n  padding: 4px 8px;\r\n  border-radius: 999px;\r\n  background: rgba(86, 22, 234, 0.08);\r\n}\r\n\r\n.team-role-badge {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  font-size: 10px;\r\n  font-weight: 600;\r\n  text-transform: uppercase;\r\n  letter-spacing: 0.4px;\r\n  padding: 3px 7px;\r\n  border-radius: 999px;\r\n  background: #e5e7eb;\r\n  color: #374151;\r\n}\r\n\r\n.team-role-badge.owner { background: #ede9fe; color: #5b21b6; }\r\n.team-role-badge.admin { background: #dbeafe; color: #1d4ed8; }\r\n.team-role-badge.write { background: #d1fae5; color: #065f46; }\r\n.team-role-badge.read  { background: #f3f4f6; color: #4b5563; }\r\n\r\n/* \"+ Create workspace\" row inside the same list */\r\n.team-ws-row.add {\r\n  border-style: dashed;\r\n  background: transparent;\r\n  color: #5616ea;\r\n  cursor: pointer;\r\n  justify-content: flex-start;\r\n  gap: 10px;\r\n}\r\n\r\n.team-ws-row.add:hover {\r\n  background: #f7f4ff;\r\n}\r\n\r\n.team-ws-add-text {\r\n  font-size: 14px;\r\n  font-weight: 600;\r\n  color: #5616ea;\r\n}\r\n\r\n/* Inline create / rename form rendered in place of a row */\r\n.team-ws-row.editing {\r\n  background: #ffffff;\r\n  border-color: #5616ea;\r\n}\r\n\r\n.team-ws-row .team-ws-edit-form {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 8px;\r\n  width: 100%;\r\n}\r\n\r\n/* --- Members table ----------------------------------------------- */\r\n.team-table-wrap {\r\n  /* Horizontally scrollable so wide tables (the 6-column Workspaces table, or\r\n     the Actions column on narrow screens) can be reached instead of spilling\r\n     off-screen. overflow-y is pinned to `hidden` rather than the default\r\n     `visible` — CSS would coerce `visible` to `auto` next to `overflow-x: auto`\r\n     and pop a vertical scrollbar on the icon hover-scale. The hover-scale stays\r\n     well within the 14px cell padding, so `hidden` never clips it. */\r\n  overflow-x: auto;\r\n  overflow-y: hidden;\r\n}\r\n\r\n/* Right-aligned cluster for action buttons (rename/leave/delete, save/cancel,\r\n   remove member, revoke invite, etc.) so they share consistent spacing. */\r\n.team-actions-row {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  gap: 8px;\r\n  justify-content: flex-end;\r\n}\r\n\r\n.team-table {\r\n  width: 100%;\r\n  /* Keep the columns readable; below this the wrapper scrolls horizontally\r\n     instead of squashing names/emails and clipping the Actions column. */\r\n  min-width: 520px;\r\n  border-collapse: collapse;\r\n  font-size: 14px;\r\n}\r\n\r\n.team-table th,\r\n.team-table td {\r\n  text-align: left;\r\n  padding: 14px 12px;\r\n  border-bottom: 1px solid #e5e7eb;\r\n  vertical-align: middle;\r\n  color: #1f2937;\r\n}\r\n\r\n/* Align the first column flush with the card title (no extra left inset). */\r\n.team-table th:first-child,\r\n.team-table td:first-child {\r\n  padding-left: 0;\r\n}\r\n\r\n.team-table th:last-child,\r\n.team-table td:last-child {\r\n  padding-right: 0;\r\n}\r\n\r\n.team-table thead th {\r\n  font-size: 12px;\r\n  text-transform: uppercase;\r\n  letter-spacing: 0.4px;\r\n  color: #5616ea;\r\n  font-weight: 600;\r\n  background: transparent;\r\n  border-bottom: 1px solid #cbd5e1;\r\n}\r\n\r\n.team-table tbody tr {\r\n  transition: background-color 0.12s ease;\r\n}\r\n\r\n.team-table tbody tr:last-child td {\r\n  border-bottom: none;\r\n}\r\n\r\n/* Workspaces table: clickable rows trigger the switch-confirm modal. */\r\n.team-table tbody tr.team-ws-tr.clickable {\r\n  cursor: pointer;\r\n}\r\n\r\n.team-table tbody tr.team-ws-tr.clickable:hover td {\r\n  background: #faf8ff;\r\n}\r\n\r\n.team-table tbody tr.team-ws-tr.clickable:focus-visible {\r\n  outline: 2px solid #5616ea;\r\n  outline-offset: -2px;\r\n}\r\n\r\n.team-table tbody tr.team-ws-tr.editing td {\r\n  background: #faf8ff;\r\n}\r\n\r\n/* Right-align the actions header to match the actions cell. */\r\n.team-table th:last-child {\r\n  text-align: right;\r\n}\r\n\r\n/* Small leading marker so each member row reads as a discrete entry\r\n   without using a clickable-feeling hover background. */\r\n.team-member-name {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  gap: 6px;\r\n}\r\n\r\n.team-member-dot {\r\n  display: inline-block;\r\n  width: 6px;\r\n  height: 6px;\r\n  border-radius: 50%;\r\n  background: #5616ea;\r\n  flex: 0 0 auto;\r\n}\r\n\r\n.team-actions-cell {\r\n  text-align: right !important;\r\n  white-space: nowrap;\r\n  width: 1%;\r\n}\r\n\r\n/* Tabs container — left aligned, single bottom margin */\r\n.team-tabs-wrap {\r\n  margin-bottom: 16px;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
